import React, { useState, useEffect } from "react";

const InputAdhar = ({
  name,
  value = "",
  onChange,
  placeholder,
  label,
  required = false,
  readOnly = false,
  setInputAdharError,
}) => {
  const [errMsg, setErrMsg] = useState("");

  const handleBlur = () => {
    const aadharRegex = /^[2-9]{1}[0-9]{11}$/;
    if (required && value?.length === 0) {
      setErrMsg("Aadhar ID is required.");
      setInputAdharError((previousState) => ({
        ...previousState,
        aadhar: true,
      }));
    } else if (value?.length > 0 && !aadharRegex.test(value)) {
      setErrMsg("Aadhar ID must be a 12-digit number starting with 2-9.");
      setInputAdharError((previousState) => ({
        ...previousState,
        aadhar: true,
      }));
    } else {
      setErrMsg("");
      setInputAdharError((previousState) => ({
        ...previousState,
        aadhar: false,
      }));
    }
  };

  const handleInputChange = (e) => {
    const inputValue = e.target.value;
    const numericValue = inputValue.replace(/\D/g, "");
    onChange({ target: { name, value: numericValue } });

    if (errMsg) {
      setErrMsg("");
      setInputAdharError((previousState) => ({
        ...previousState,
        aadhar: false,
      }));
    }
  };

  useEffect(() => {
    if (!errMsg) {
      setInputAdharError((previousState) => ({
        ...previousState,
        aadhar: false,
      }));
    }
  }, [errMsg, setInputAdharError]);

  return (
    <>
      <div className="form-group">
        <label htmlFor={name} className="col-form-label">
          {label}:
        </label>
        <input
          type="text"
          className="form-control"
          name={name}
          value={value}
          onChange={handleInputChange}
          onBlur={handleBlur}
          placeholder={placeholder}
          required={required}
          readOnly={readOnly}
          maxLength={12}
        />
      </div>
      <small className="text-danger">{errMsg}</small>
    </>
  );
};

export default InputAdhar;
